import { evolve, filter, flatMap, piped, prop, sortBy } from "remeda";
//#region src/utils/navigation.ts
const createNavigationGroupFilter = (targetLayoutRegion) => (group) => {
	switch (targetLayoutRegion) {
		case "footer": return "menuOnly" in group ? !group.menuOnly : true;
		case "header": return "footerOnly" in group ? !group.footerOnly : true;
		default: return true;
	}
};
const getLayoutRegionNavigationDirectory = (targetLayoutRegion, globalDirectory) => {
	const groupFilter = createNavigationGroupFilter(targetLayoutRegion);
	return evolve(globalDirectory, {
		labeledLinks: (linkGroup) => filter(linkGroup, groupFilter),
		iconLinks: (linkGroup) => filter(linkGroup, groupFilter)
	});
};
const orderLinksByGlobalPriority = (links) => sortBy(links, (link) => "globalPriority" in link ? link.globalPriority : Number.POSITIVE_INFINITY);
/**
* Extracts links from navigation groups into flat arrays ordered by global priority,
* while preserving segregation by link type
*/
const extractNavigationCatalog = (navigationDirectory) => evolve(navigationDirectory, {
	labeledLinks: piped(flatMap(prop("items")), orderLinksByGlobalPriority),
	iconLinks: (navGroups) => navGroups?.flatMap(piped(prop("items"), orderLinksByGlobalPriority))
});
//#endregion
export { extractNavigationCatalog, getLayoutRegionNavigationDirectory, orderLinksByGlobalPriority };

//# sourceMappingURL=navigation.js.map